/* Loop applies a shop-currency discount to Shopify's localized component prices. */
(() => {
  function quote(definition, rate) {
    const retail = Number(definition.presentmentRetail);
    const baseRetail = Number(definition.retail);
    rate = Number(rate);
    if (!(retail > 0 && baseRetail > 0 && rate > 0)) return null;
    const net = (basePrice) => Math.max(0, retail - Math.round((baseRetail - Number(basePrice)) * rate));
    return { retail, oneTime: net(definition.oneTime), monthly: net(definition.monthly) };
  }
  function cartRetail(group) {
    return group.items.reduce((total, item) => total + Number(item.original_line_price ?? Number(item.original_price ?? item.price) * item.quantity), 0);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { quote, cartRetail };
  if (typeof window === 'undefined') return;
  const currency = () => window.Shopify?.currency?.active || 'USD';
  const format = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: currency(), minimumFractionDigits: cents % 100 === 0 ? 0 : 2, maximumFractionDigits: 2
  }).format(cents / 100);
  const definitions = () => JSON.parse(document.getElementById('pp-bundle-cart-config')?.textContent || '[]');
  function localize(root) {
    const definition = definitions().find((entry) => Number(entry.productId) === Number(root.dataset.bundleProduct));
    if (!definition) return;
    const prices = quote(definition, window.Shopify?.currency?.rate || 1);
    if (!prices) return;
    root.dataset.oneTimePrice = format(prices.oneTime);
    root.dataset.subscriptionPrice = format(prices.monthly);
    root.dataset.presentmentOneTimeCents = String(prices.oneTime);
    root.dataset.presentmentSubscriptionCents = String(prices.monthly);
    for (const [mode, cents] of [['oneTime', prices.oneTime], ['subscription', prices.monthly]]) {
      const percent = Math.round((prices.retail - cents) / prices.retail * 100);
      root.dataset[mode + 'Savings'] = percent > 0 ? root.dataset.savingsTemplate.replace('__PERCENT__', String(percent)) : '';
    }
    root.querySelectorAll('.pp-bundle-anchor').forEach((element) => { element.textContent = format(prices.retail); });
    const schemaElement = document.querySelector('[data-pp-bundle-schema="' + definition.productId + '"]');
    if (schemaElement) {
      const schema = JSON.parse(schemaElement.textContent);
      schema.offers.price = prices.oneTime / 100;
      schema.offers.priceCurrency = currency();
      schemaElement.textContent = JSON.stringify(schema);
      const priceMeta = document.querySelector('meta[property="og:price:amount"]');
      const currencyMeta = document.querySelector('meta[property="og:price:currency"]');
      if (priceMeta) priceMeta.content = (prices.oneTime / 100).toFixed(2);
      if (currencyMeta) currencyMeta.content = currency();
    }
  }
  window.PurePatchBundleMoney = { quote, cartRetail, localize };
})();
